import cn from 'clsx'
import Clickable from 'components/Common/Clickable'
import Image from 'components/Common/Image'
import CheckboxButton from 'components/Luxkit/Checkbox/CheckboxButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Sheet from 'components/utils/Sheet'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { UserPreferenceHolidayOrBrands } from '../types'

const Item = styled(Clickable)`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`

const ImageSheet = styled(Sheet)`
  position: relative; /* for the floating checkbox */
  aspect-ratio: 3/2;
`

const FloatingCheckbox = styled(CheckboxButton)`
  position: absolute;
  top: ${rem(8)};
  right: ${rem(8)};
  opacity: 0;
  transition: opacity 0.2s;

  &.visible {
    opacity: 1;
  }
`

interface Props {
  item: UserPreferenceHolidayOrBrands
  isSelected: boolean
  onSelect: (item: UserPreferenceHolidayOrBrands) => void
  showLabel: boolean
}

function TravelPreferencesOptionItem({
  item,
  isSelected,
  onSelect,
  showLabel,
}: Props) {
  const handleClick = useCallback(() => {
    onSelect(item)
  }, [item, onSelect])

  return <Item onClick={handleClick}>
    <ImageSheet border={isSelected ? 'primary' : 'transparent'} borderWidth={2} background="neutral-eight">
      {!!item.image && <Image
        id={item.image}
        alt={item.name}
        fit="center"
        aspectRatio="3:2"
        width="192"
        dpr={2}
      />}
      <FloatingCheckbox size="large" checked className={cn({ visible: isSelected })}/>
    </ImageSheet>

    {showLabel && <BodyText colour="neutral-two" weight="bold" variant="medium">{item.name}</BodyText>}
  </Item>
}

export default TravelPreferencesOptionItem
